export const headline = {
  title: 'Clinically validated to support whole-body health.',
  body: 'Every formula is rigorously tested—not just to meet industry standards, but to exceed them. Better health starts with better science.',
  primaryButton: {
    label: 'Shop now',
    url: '#',
  },
};

export const dsDuoItems = [
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758127083/library/highlight/Frame_1739333908_2.png',
      alt: 'A jar of DS-10 and a jar of DM-02',
    },
  },
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758117791/library/highlight/1de23b9c19a1b7098203106cb8647453916e1416.png',
      alt: 'Taking pill out of DM-02 jar',
    },
  },
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758117774/library/highlight/2_1.png',
      alt: 'Unboxing products',
    },
  },
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758053476/library/highlight/cd4fcd333d2d2c517ca600e6ee9efbbaf896fded.png',
      alt: 'A jar of DS-10 and a jar of DM-02 with plant behind them',
    },
  },
];

export const cobioticsItems = [
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761840059/library/highlight/product-highlight-1.png',
      mobileSrc:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761929083/library/highlight/mobile-top-image.png',
      alt: 'Three jars of seed products are displayed in front of a glass of water - AM-02, DM-02, and PM-02',
    },
  },
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761850530/library/highlight/highlight-2-desktop.png',
      mobileSrc:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761844471/library/highlight/highlight-2.png',
      alt: 'Opening PM-02 jar',
    },
  },
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761850530/library/highlight/highlight-3-desktop.jpg',
      mobileSrc:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761844459/library/highlight/highlight-3.png',
      alt: 'DM-02 viacap demonstration',
    },
  },
  {
    media: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1761840057/library/highlight/highlight-4.png',
      alt: 'A jar of AM-02 on top of a desk with a mug and a glass of water behind it',
    },
  },
];

export const leftRight = {
  items: [
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/highlight/bacteria.jpg',
        alt: 'Product image',
      },
      title: 'Lectus gravida mauris quisque, sem lectus',
      pill: 'DS-01®',
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887666/library/highlight/product-full.png',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887664/library/highlight/pills.jpg',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887659/library/highlight/portrait.png',
        alt: 'Product image',
      },
    },
  ],
};

export const video = {
  items: [
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/video/upload/f_auto,q_auto/v1748887700/library/highlight/video-placeholder.mp4',
        alt: 'Product image',
      },
      title: 'Lectus gravida mauris quisque, sem lectus',
      pill: 'DS-01®',
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887666/library/highlight/product-full.png',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887664/library/highlight/pills.jpg',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887659/library/highlight/portrait.png',
        alt: 'Product image',
      },
    },
  ],
};

export const below = {
  items: [
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887666/library/highlight/product-full.png',
        alt: 'Product image',
      },
    },
  ],
};

export const below2 = {
  items: [
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887666/library/highlight/product-full.png',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887666/library/highlight/product-full.png',
        alt: 'Product image',
      },
    },
  ],
};

export const below3 = {
  items: [
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887666/library/highlight/product-full.png',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887664/library/highlight/pills.jpg',
        alt: 'Product image',
      },
    },
    {
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887659/library/highlight/portrait.png',
        alt: 'Product image',
      },
    },
  ],
};
